import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Pictogram from '../pictogram';
import useWizard from '../wizard/useWizard';
import TranslatedCopy from '../../../intl/translated-copy';

const ModalSpecialRefund = ({
  documentNumbers,
  onConfirmRefund,
  stateStoreFront,
}) => {
  const {
    quotationsToRender,
    setSpecialRefundModal,
  } = useWizard();

  // INFO: Only the passengers checked in RefundBreakdown should count towards the total shown here
  const selectedDocumentNumbers = (documentNumbers || []).map(doc => doc?.documentNumber);
  const selectedQuotations = selectedDocumentNumbers.length > 0
    ? (quotationsToRender || []).filter(quotation => selectedDocumentNumbers.includes(quotation?.documentNumber))
    : (quotationsToRender || []);

  const total = selectedQuotations.reduce((sum, quotation) => {
    return sum + (quotation?.quoteItemAmount?.dAmount || 0);
  }, 0);
  const currencyOfRefund = quotationsToRender?.[0]?.quoteItemAmount?.currencyCode || 'MXN';
  // BUSINESS: Number of decimals comes from the backend storefront config (numberOfDecimalsBE); defaults to 0 when not provided
  const numberOfDecimalsBE = stateStoreFront?.numberOfDecimalsBE != null ? stateStoreFront.numberOfDecimalsBE : 0;
  const formattedTotal = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: numberOfDecimalsBE,
    maximumFractionDigits: numberOfDecimalsBE,
  }).format(total);

  const confirmSpecialRefund = () => {
    setSpecialRefundModal(false);
    if (onConfirmRefund) {
      onConfirmRefund();
    }
  };

  return (
    <div className='ModalSpecialRefund'>
      <div className='ModalSpecialRefund-details'>
        <button
          aria-label='Close'
          className='ModalSpecialRefund-details-closeBtn'
          onClick={ () => setSpecialRefundModal(false) }
          type='button'
        >
          <Pictogram className='ModalSpecialRefund-details-closeBtn--closeIcon' id='Close' />
        </button>
        <Pictogram className='ModalSpecialRefund-details--alertIcon' id='RefundSpecial' />
        <div className='ModalSpecialRefund-details-warning'>
          <TranslatedCopy
            className='ModalSpecialRefund-details-warning--warningMsg'
            copyID='MYB_REFUND_SPECIAL_MODAL_TITLE'
            tagName='p' />
          <TranslatedCopy
            className='ModalSpecialRefund-details-warning--confirmationAlertText'
            copyID='MYB_REFUND_SPECIAL_MODAL_QUESTION'
            tagName='p' />
          <p className='ModalSpecialRefund-details-warning--confirmationAlertDesc'>
            <TranslatedCopy
              copyID='MYB_REFUND_SPECIAL_MODAL_REVIEW_AMOUNT'
              tagName='span' />
            <br />
            <TranslatedCopy
              copyID='MYB_REFUND_SPECIAL_MODAL_IRREVERSIBLE'
              tagName='span' />
          </p>
        </div>
        <div className='ModalSpecialRefund-details-total'>
          <TranslatedCopy
            className='ModalSpecialRefund-details-total--label'
            copyID='MYB_REFUND_SPECIAL_MODAL_TOTAL_LABEL'
            tagName='p'
          />
          <div className='ModalSpecialRefund-details-total--amountContainer'>
            <span className='ModalSpecialRefund-details-total--amount'>{ `$${ formattedTotal }` }</span>
            <span className='ModalSpecialRefund-details-total--currency'>{ currencyOfRefund }</span>
          </div>
        </div>
        <div className='ModalSpecialRefund-details-actions'>
          <button
            className='ModalSpecialRefund-details-actions--cancelBtn'
            onClick={ () => setSpecialRefundModal(false) }
            type='button'
          >
            <TranslatedCopy copyID='MYB_REFUND_SPECIAL_MODAL_CANCEL' />
          </button>
          <button
            className='ModalSpecialRefund-details-actions--confirmBtn'
            onClick={ () => confirmSpecialRefund() }
            type='button'
          >
            <TranslatedCopy copyID='MYB_REFUND_SPECIAL_MODAL_CONFIRM' />
          </button>
        </div>
      </div>
    </div>
  );
};

ModalSpecialRefund.propTypes = {
  documentNumbers: PropTypes.array,
  onConfirmRefund: PropTypes.func,
  stateStoreFront: PropTypes.object,
};

const mapStateToProps = (state) => ({
  documentNumbers: state.refundPassengerList.documentNumbers,
  stateStoreFront: state.Manage.stateStoreFront,
});

export default connect(mapStateToProps)(ModalSpecialRefund);